import * as React from 'react';
import { connect } from 'react-redux';

import { ApplicationState } from '../../store';
import * as User from '@store/user';
import { WorkUsers } from '@components/users/WorkUsers';

export default connect(
    (state: ApplicationState) => ({
        ...state.identity,
        ...state.user,
        ...User.plainActions,
        work: state.user.work,
    }),
    User.actionCreators,
)(WorkUsers as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
